import TranslationOffice from "./Translation";
import { BasePage } from "components/BasePage/BasePage";

export const TranslationOfficePage = () => {
  return (
    <BasePage
      breadcrumbItems={[
        {
          label: "sidebar.nav.translationOffice",
          location: "/_backoffice/translation-office",
        },
        {
          label: "powersearch.title",
          location: "/_backoffice/translation-office",
        },
      ]}
    >
      <div className="">
        <div>
          <TranslationOffice />
        </div>
      </div>
    </BasePage>
  );
};
